if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
      this.customVariantPicker = document.querySelector("custom-variant-picker");
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(event) {
      event.preventDefault();
      
      
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
      const miniCardProductId = document.querySelector(".card-info-id");
      const variants = this.form.getAttribute('variants');
      let defaultOptionID = this.form.getAttribute('default-option');
      const input = document.querySelector('.qty-input__input');
      let variantsSelectionRadio = document.querySelector('input.opt-btn:checked');
      if(variantsSelectionRadio) {
        defaultOptionID = variantsSelectionRadio.getAttribute('variant-id');
      }
      if(!defaultOptionID && miniCardProductId) {
        defaultOptionID = miniCardProductId.getAttribute("productId");
      }
      
      
      const defaultOption = {
        "id": this.customVariantPicker ? this.customVariantPicker.selectedVariantId : defaultOptionID,
        "quantity": input?.value || 1
      }
      let variantsToSend = variants ? variants : JSON.stringify({'items': [defaultOption]})
      
      
      
      // fetch('  https://f3f0-89-208-129-237.ngrok-free.app/addToCartParameters', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify({variantsToSend: input?.value || 1} ) 
      // })
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: variantsToSend  
      })
      .then(async response => {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(async () => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
          
          if(variants) {
            const inputs = document.querySelectorAll(".input_qty");
            inputs.forEach((el) => {
              el.value = null;
            })
          } else if(input) {
            input.value = 1;
          }         
          const tableTotalPrice = document.querySelector('.total_price');
          if(tableTotalPrice) {
            tableTotalPrice.innerHTML = "Total: $0.00"
            document.querySelector('.total_qty').innerHTML = "Quantity: "+ 0 ;
          }
          // Get cart count
            const res = await fetch("/cart.js");
            const cart = await res.json();
            if(unitPrice) {
              mainPriceLabel.innerHTML = unitPrice;
            }
            updateCartItemCounts(cart.item_count);

            // Update cart
            await updateCartDrawer();

            // Open cart drawer
            openCartDrawer();
            addRemoveButtonEventListener();
        }, 1400);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }

  const addRemoveButtonEventListener = () => {
    const removeFromCartButtons = document.querySelectorAll(".remove-icon-buttons");
    removeFromCartButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        let itemId = button.getAttribute("item-id");
        let update = { [itemId]: 0 }
        updateCartRequest(update)
      })
    })
  }

  const updateCartRequest = (update) => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({updates: update})
    })
    .then(async response => {
      const responseData = await response.json()
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);
      
      // Update cart
      await updateCartDrawer();
      addRemoveButtonEventListener();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  function openCartDrawer() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  }
  
  function closeCartDrawer() {
    document
      .querySelector(".cart-drawer")
      .classList.remove("cart-drawer--active");
  }
  
  function updateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = count;
    });

    const cartIconBubble = document.querySelector('.header__cart-count-number');
    cartIconBubble.innerHTML = count;
  }
  
  async function updateCartDrawer() {
    request();
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const newBox = html.querySelector(".cart-drawer").innerHTML;
    document.querySelector(".cart-drawer").innerHTML = newBox;
    addCartDrawerListeners();
  }
  
  function addCartDrawerListeners() {
    // Update quantities
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Get line item key
          const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
          .parentElement;
          
          const key = rootItem.getAttribute("data-line-item-key");
          const alternateKey = button.getAttribute("data-line-item-key");
          // Get new quantity
          const currentQuantity = Number(
            button.parentElement.querySelector("input").value
          );
          const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
          );
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
  
          
          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key || alternateKey]: newQuantity } }),
          });
          const cart = await res.json();
  
          updateCartItemCounts(cart.item_count);
  
          // Update cart
          updateCartDrawer();
        });
      });
  
    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
      e.stopPropagation();
    });
  
    document
      .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          if (!event.target.getAttribute("class").includes("remove-icon")) {
            console.log("closing drawer");
            closeCartDrawer();
          }
        });
      });
  }
  
  addCartDrawerListeners();

  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });


  const mainPriceLabelClassSelector = ".price__current .transcy-money";
  const mainPriceLabel = document.querySelector(mainPriceLabelClassSelector);
  
  const unitPrice = mainPriceLabel && mainPriceLabel.innerHTML;
  const clearAllLabel = document.getElementById("clear-all-div");

  clearAllLabel?.addEventListener("click", () => {
    window.location.reload();
  })
  
    function disableInputs(input, product){
      for(var i=0; i < input.length; i++){
        let col_index = input[i].getAttribute('data-col-index');
        let row_index = input[i].closest('.opt2-row').getAttribute('data-row-index');
        let val_opt1 = document.querySelector('.opt1-head-'+col_index+'').getAttribute('data-opt-value');
        let val_opt2 = document.querySelector('.opt2-head-'+row_index+'').getAttribute('data-opt-value');
        input[i].setAttribute('data-variant-title', val_opt1+" / "+val_opt2);

        let variants = product['product']['variants'];
        for(var j=0; j < variants.length; j++){
            if(variants[j].title == val_opt1+" / "+val_opt2){
              let quantity = parseInt(document.querySelector('.var-qty-'+variants[j].id+'').value);
              input[i].setAttribute('data-variant-id', variants[j].id);
              input[i].setAttribute('data-variant-price', variants[j].price);
              input[i].setAttribute('data-variant-sku', variants[j].sku);
              if(quantity <= 0){
                input[i].setAttribute('disabled', 'disabled');
              }
            }
        }
      }
    }

  function handleCustomerInteraction(response){
    let input = document.querySelectorAll('.input_qty');
    let product = JSON.parse(response);
    disableInputs(input, product);
    var selected_variants = [];
    for(var i=0; i < input.length; i++){
       input[i].addEventListener('input', function(){
          let val = this.value;
          let count = 0;
         let sku = this.getAttribute('data-variant-sku')
          let obj = {
            "id": this.getAttribute('data-variant-id'),
            "quantity": this.value,
            "price": parseFloat(this.getAttribute('data-variant-price')),
          };

          // if the val verible as a value and the value is bigger then zero
          if(!isNaN(val) && parseInt(val) > 0){
            
            // if the length of the selected_variants array is bigger then zero
            if(selected_variants.length > 0){
              // we are running on the selected_variant array
              for(var i=0; i < selected_variants.length; i++){
                // if the selected_variants[i] is equal to the varient that the current input belong to
                if(selected_variants[i].id == this.getAttribute('data-variant-id'))
                {
                  // we are setting the selected_variants[i] quantity to the current value that is found on the current input
                  selected_variants[i].quantity = this.value;
                  count++;
                }
              }
              // if count equal to zero it's meanning that the specific varient was'nt
              // on the selected_variants array before and now I'm insert it and is quantity suppost to be equal to the current input value
              if(count == 0)
              {
                selected_variants.push(obj);
              }
            }
              // if I'm getting to this else this is meaning that the selected_variants array was empty untill now
            else{
              selected_variants.push(obj);
            }
          }
            // if the val of the current input is equal to zero we are looking for this varient  on  the selected_variants array and cutting it from the array
            // if it is found there and rendering the total price again
          else if(val == 0 || val == "" || val.trim().length == 0){
            if(selected_variants.length > 0){
              for(var i=0; i < selected_variants.length; i++){
                if(selected_variants[i].id == this.getAttribute('data-variant-id'))
                {
                  selected_variants.splice(i, 1);
                }
              }
            }
          }
          else if(selected_variants.length > 0){
            for(var i=0; i < selected_variants.length; i++){
              if(selected_variants[i].id == this.getAttribute('data-variant-id'))
              {
                selected_variants[i].quantity = this.value;
              }
            }
          }
         renderPriceQuantity(selected_variants, product, sku, obj.price)
         if(selected_variants.length === 0) {
            clearAllLabel.hidden = true
         } else {
          clearAllLabel.hidden = false
         }
        });
    }
  }

  function renderPriceQuantity(selected_variants, product, sku, unitprice) {
    const total_quantity = selected_variants.reduce((accumulator, curValue) => accumulator + parseInt(curValue.quantity), 0);
    let totalPrice = 0;
    let exactPrice = 0;
    for(let i = 0; i < selected_variants.length; i++) {
      if(total_quantity < 3) {
        totalPrice = totalPrice + (selected_variants[i].price * selected_variants[i].quantity);
      } else {
        totalPrice = totalPrice + (calcPriceAfterDiscount(selected_variants[i].price, total_quantity) * selected_variants[i].quantity);
      }
      exactPrice = exactPrice + (selected_variants[i].price * selected_variants[i].quantity);
    }
    document.querySelector('.total_qty').innerHTML = "Quantity: "+total_quantity;
    if(total_quantity >= 3) {
      document.querySelector('.total_price').innerHTML = "Total: <span style='text-decoration: line-through;color: red;margin-right: 5px;'>$"+exactPrice.toFixed(2)+"</span> $"+totalPrice.toFixed(2);
      document.querySelector(mainPriceLabelClassSelector).innerHTML = "Total: <span style='text-decoration: line-through;color: red;margin-right: 5px;'>$"+exactPrice.toFixed(2)+"</span> $"+totalPrice.toFixed(2);
    } else {
      document.querySelector('.total_price').innerHTML = "Total: $" + exactPrice.toFixed(2);
      if(total_quantity === 0) {
        document.querySelector(mainPriceLabelClassSelector).innerHTML = "$" + unitprice.toFixed(2)
      } else {
        document.querySelector(mainPriceLabelClassSelector).innerHTML = "Total: $" + exactPrice.toFixed(2);
      }
    }
    document.querySelector('.product-sku__value').innerHTML = sku;
    const product_form_id = document.querySelector('.prod-form-id').value;
    const product_form = document.getElementById(product_form_id);
    let variant = selected_variants.map(v => { return {'id': v.id, 'quantity': v.quantity}})
    product_form.setAttribute('variants', JSON.stringify({'items': variant}));
  }

  function calcPriceAfterDiscount(unitPrice, total_quantity) {
    if(total_quantity >= 3 && total_quantity < 5) {
      // 5% precent
      return unitPrice - (unitPrice * 0.05);
    } else if(total_quantity >= 5 && total_quantity < 10) {
      // 7% precent
      return unitPrice - (unitPrice * 0.07);
    }
    // 10% precent
    return unitPrice - (unitPrice * 0.1);
  }

  function request(){
    let handle = document.querySelector('.prod-handle')
    if(handle) {
      handle = handle.value;
      const xhttp = new XMLHttpRequest();
      xhttp.onload = function() {
        handleCustomerInteraction(this.responseText);
      }
      xhttp.open("GET", "/products/"+ handle +".json", true);
      xhttp.send();
    }
  }

  request();
  customElements.define('product-form', ProductForm);
}


// const removeCartButton = document.getElementById("removecart");
  // if(removeCartButton) {
  //   removeCartButton.addEventListener("click", (event) => {
  //     event.preventDefault();
  //     console.log("remove");
  //     fetch(window.Shopify.routes.root + 'cart/clear.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }).then(async response => {
  //       console.log(response);
  //       await updateCartDrawer();
  //       updateCartItemCounts(0);
  //     }).catch(error => {
  //       throw new Error(error);
  //     })
  //   })
  // }

  // function removeCart() {
  //   event.preventDefault();
  //     console.log("remove");
  //     fetch(window.Shopify.routes.root + 'cart/clear.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }).then(async response => {
  //       console.log(response);
  //       await updateCartDrawer();
  //       updateCartItemCounts(0);
  //     }).catch(error => {
  //       throw new Error(error);
  //     })
  // }
  
 
// This part of code is for backup and not working as well yet

// function calcPriceAfterDiscount(unitPrice, total_quantity) {
//   if(total_quantity >= 3 && total_quantity < 5) {
//     // 5% precent
//     return ((unitPrice - (unitPrice * 0.05)) * total_quantity).toFixed(2);
//   } else if(total_quantity >= 5 && total_quantity < 10) {
//     // 7% precent
//     return ((unitPrice - (unitPrice * 0.07)) * total_quantity).toFixed(2);
//   }
//   // 10% precent
//   return ((unitPrice - (unitPrice * 0.1)) * total_quantity).toFixed(2);
// }

// const discountPrice = document.querySelectorAll(".span-price-discount");

// function showPriceAfterDiscount(element) {
//   console.log("working....");
//   let price = element.getAttribute("price") / 100
//   price = price.toFixed(2);
//   let qty = element.getAttribute("qty");
//   element.innerHTML = "$" + calcPriceAfterDiscount(price, qty)
// }

// function discountPriceIterations() {
//   discountPrice.forEach(element => {
//     const elementById = document.getElementById(element.getAttribute("id"));
//     showPriceAfterDiscount(elementById);
//   })
// }
// if (discountPrice) {
//   discountPriceIterations();
// }


// const pluseButton = document.querySelectorAll('.cart-drawer-quantity-selector-plus');
// const minuseButton = document.querySelectorAll('.cart-drawer-quantity-selector-minus');


// pluseButton.forEach(element => {
//   const elementById = document.getElementById(element.getAttribute("id"));
//   elementById.addEventListener("click", () => {
//     console.log("click+");
//     if(discountPrice) {
//       discountPriceIterations();
//     }
//   })
// })

// minuseButton.forEach(element => {
//   const elementById = document.getElementById(element.getAttribute("id"));
//   elementById.addEventListener("click", () => {
//     console.log("click-");
//     if(discountPrice) {
//       discountPriceIterations();
//     }
//   })
// })